'use strict';
import * as _ from 'lodash';

export class CropDialogModel {
  file = null;
  fileURL = null;
  cropper = null;
  title = 'Edit Image';
  cropperSettings = null;
  constructor(fileObject, isIOS) {
    if (fileObject){
      this.file = {
        originalFile: fileObject, 
      }
      this.fileURL = URL.createObjectURL(this.file.originalFile);
    }

    this.cropperSettings = {
      file: fileObject,
      isIOS: isIOS,
    };
  }

  init(modal, scope, modalService, ionicDatePicker) {
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
    this.ionicDatePicker = ionicDatePicker;
  }

  loadFromExistingData(imageData, isIOS) {
    this.file = imageData;
    this.cropperSettings = {
      file: this.file.originalFile,
      croppedData: imageData.canvasData,
      isIOS: isIOS,
    }

    return this;
  }

  async closeWindow() {
    const confirmed = await this.modalService.showConfirmation(null, 'Are you sure you want to cancel?');
    if (confirmed) {
      this.isCancelled = true;
      this.modalInstance.remove();
    }
    return;
  }

  async save() {
    const saveObject = await this.cropperSettings.getSaveObject();
    this.file.croppedBlob = saveObject.croppedBlob;
    this.file.fileURL = URL.createObjectURL(saveObject.croppedBlob);
    this.file.canvasData = saveObject.canvasData,
    this.file.croppedData = saveObject.croppedData,
    this.file.fileSize = saveObject.croppedBlob.size,
    this.modalInstance.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/cropDialogModel.js